var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"currencysymbol",class:{'fontWeight':_vm.fontWeight}},[_vm._v(" "+_vm._s(_vm.getSymbolFromCurrency(_vm.$store.state.checkoutcurrency))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }